<template>
<v-app>
    <v-main>
        <div v-if="loading" class="loader">
            <div class="spinner"></div>
        </div>
        <router-view />
    </v-main>
</v-app>
</template>

<script>
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

export default {
    name: 'App',

    data: () => ({
        //
    }),
    setup() {
        const router = useRouter();
        const loading = ref(false);

        watch(router.currentRoute, (to, from) => {
        loading.value = true;
        setTimeout(() => {
            loading.value = false;
        }, 1000); // Simulate API delay
        });

        return { loading };
    },
}
</script>

<style lang="scss">
@import '@/assets/style/custom.scss';
@import '@/assets/style/mixin.scss';
@import '@/assets/style/variables.scss';

</style>

<style>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #ccc;
  border-top-color: #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  100% { transform: rotate(360deg); }
}
</style>